<template>
    <the-section
        class="flex flex-col projects"
        legend="Won battles"
        id="battles"
    >
        <!-- <project-filters v-model="type" /> -->
        <project-cover
            v-for="(project, index) in projects"
            :key="project.id"
            :reverse="index % 2 !== 0"
            :project="project"
        />
    </the-section>
</template>

<script setup>
import ProjectCover from "@/components/ProjectCover";
// import ProjectFilters from "@/components/ProjectFilters";
import TheSection from "@/components/TheSection";
import { useStore } from "@/store";
import { computed, ref } from "vue";

const store = useStore();

const type = ref("service");

const projects = computed(() => {
    const _projects = [...store.state.projects.values()];

    return _projects;

    // if (type.value === "service") {
    //     return _projects;
    // }

    // return _projects.filter(
    //     (project) => type.value !== null && project.type === type.value
    // );
});

// Access $store.state.projects here anf filter by type
</script>

<style lang="sass">
.projects
    gap: calc(var(--line-base) * 4)
    padding-top: calc(var(--line-base) * 4)
    padding-bottom: calc(var(--line-base) * 9)

.legend
    opacity: .67
    color: #FFF
</style>
